import React, { useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import "./iitBombayTechfestCertificate.css";
import { PERSON_AWARD, MESSAGE, SUCCESS_IMAGE } from '../../../constant';
import TextInputField from '../../commanComponents/textInputField/textInputField';
import BaseNavbar from '../../commanComponents/navbar/baseNavbar';
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';
import { downloadIITBombayFestService } from '../../../modules/services';


const IITBombayTechfestCertificate = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessSection, setShowSuccessSection] = useState(false);

    const loginSchema = z.object({
        //student_name
        student_name: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "First Name") }),
        //email
        email: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Email") }).email({ message: MESSAGE.EMAIL_INVALID }),
    });
    
    const { register, handleSubmit, control, formState: { errors }, getValues } = useForm({
        resolver: zodResolver(loginSchema)
    });

    const handleCompetetionSubmission = (data) => {
        setIsLoading(true);
        (async () => {
            const responseData = await downloadIITBombayFestService(data, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setIsLoading(false);
                setShowSuccessSection(true);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                window.location.href = "https://fizrobotics.com/";
            }
        })();
    }

    return (
        <>
            <BaseNavbar />
            <div className='row main-row'>
                {
                    !showSuccessSection
                    ?
                    <>
                        <div className='col iit-bombay-left-img-div'>
                            <img
                                src={PERSON_AWARD}
                                alt='ai_robot'
                                className='robot_img'
                            />
                        </div>
                        <div className='col'>
                            <div className='nef-main-div'>
                                <div className='nef-form-div'>
                                    <Form onSubmit={handleSubmit(handleCompetetionSubmission)}>
                                        <Form.Label className='heading'>
                                            Techkriti'26 IIT Kanpur Certification Portal
                                        </Form.Label>
                                        <Form.Label className='sub-heading'>
                                            Fill your exact details to download your certificate
                                        </Form.Label>
                                        <div className='row add-mentor-input-row'>
                                            <div className='col-sm'>
                                                <TextInputField
                                                    placeholder="Student name"
                                                    fieldType="text"
                                                    errorMessage={errors.student_name?.message}
                                                    inputKey="student_name"
                                                    maxWidth="400px"
                                                    formRegister={register}
                                                />
                                            </div>
                                        </div>
                                        <div className='row add-mentor-input-row'>
                                            <div className='col-sm'>
                                                <TextInputField
                                                    placeholder="Email"
                                                    fieldType="text"
                                                    errorMessage={errors.email?.message}
                                                    inputKey="email"
                                                    maxWidth="400px"
                                                    formRegister={register}
                                                />
                                            </div>
                                        </div>
                                        <div className='submit-button-div' style={{marginTop: "40px"}}>
                                            <PrimaryButton
                                                text="DOWNLOAD"
                                                type={"submit"}
                                                isLoading={isLoading}
                                                customStyle={{height: "40px"}}
                                            />
                                        </div>
                                        <Form.Label className='nef-bottom-description'>
                                            <b>Note:</b> In case of any query, feel free to reach us on contact@fizrobotics.com
                                        </Form.Label>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div style={{textAlign: "center", paddingTop: "5%"}}>
                            <label className='heading' style={{marginBottom: "1%"}}>
                                Certificate downloaded Successfully.
                            </label>
                            <label className='sub-heading' style={{marginBottom: "2%"}}>
                                Thank you for participating in our workshop.
                            </label>
                            <img 
                                src={SUCCESS_IMAGE}
                                alt='ai_robot'
                                className='success-image'
                            />
                        </div>
                    </>
                }
                
            </div>
        </>
    );
}

export default IITBombayTechfestCertificate;
